export const REVIEW_YOUR_INFORMATION_PAGE_PROGRESS_VALUE = 75;
export const REVIEW_YOUR_INFORMATION_COMPLETION_FRACTION = "3/4";
export const REVIEW_YOUR_INFORMATION_HEADING =
  "review-your-information-heading";
export const REVIEW_YOUR_INFORMATION_NAME_AND_CONTACT_SECTION =
  "review-your-information-name-and-contact-section";
export const REVIEW_YOUR_INFORMATION_EDIT = "review-your-information-edit";
export const REVIEW_YOUR_INFORMATION_FIRST_NAME =
  "review-your-information-first-name";
export const REVIEW_YOUR_INFORMATION_LAST_NAME =
  "review-your-information-last-name";
export const REVIEW_YOUR_INFORMATION_DATE_OF_BIRTH =
  "review-your-information-date-of-birth";
export const REVIEW_YOUR_INFORMATION_VERIFICATION_METHOD =
  "review-your-information-primary-verification-method";
export const REVIEW_YOUR_INFORMATION_ACCOUNT_SETUP_SECTION =
  "review-your-information-account-setup-section";
export const REVIEW_YOUR_INFORMATION_USERNAME =
  "review-your-information-username";
export const REVIEW_YOUR_INFORMATION_PASSWORD =
  "review-your-information-password";
export const REVIEW_YOUR_INFORMATION_NAME_AND_CONTACT_SECTION_EDIT =
  "review-your-information-name-and-contact-section-edit";
export const REVIEW_YOUR_INFORMATION_ACCOUNT_SETUP_SECTION_EDIT =
  "review-your-information-account-setup-section-edit";
export const REVIEW_YOUR_INFORMATION_LABEL_DELIMITER = ":";
export const REVIEW_YOUR_INFORMATION_EMAIL_LANGUAGE_LABEL =
  "review-your-information-email-language";
